import { GenericLogsPage } from "../../Everou/_components/GenericLogsPage";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { PMSLocationsActions } from "../_actions/PMSLocationsActions";
import { Selectors } from "../../Everou/_reducers/app.reducer";
import { LogModel } from "../../Everou/_models/LogModel";
import { LogsTable } from "../../Everou/DevicesModule/LogsTable";
import { TimeHelper } from "../../Everou/_helpers";

export function PMSLocationProtectLogs() {

    // LIBRARIES
    const dispatch = useDispatch();

    // GLOBAL STATE
    let logs = [LogModel()];
    logs = useSelector(Selectors.getPMSLocationProtectLogs);

    const nextPage = useSelector(Selectors.getPMSLocationProtectLogsNextPage);
    const { begin, end } = useSelector(Selectors.getPMSLocationProtectLogsDateFilter);
    const isRequesting = useSelector(Selectors.getPMSLocationProtectLogsIsRequesting);
    const isRequestingFirst = useSelector(Selectors.getPMSLocationProtectLogsIsRequestingFirst);
    const timezone = useSelector(Selectors.getPMSLocationSelectedTimezone);
    const locationUid = useSelector(Selectors.getPMSLocationSelectedUid);
    const devices = useSelector(Selectors.getPMSLocationDevices);

    // ACTION HANDLERS
    const handleRefreshLogs = () => dispatch(PMSLocationsActions.getProtectLogsFirstPage());
    const handleNextPage = () => dispatch(PMSLocationsActions.getProtectLogsNextPage(nextPage, isRequesting));
    const handleLogsDateStartChange = date => dispatch(
        PMSLocationsActions.setProtectLogsDateFilter({
            begin: date,
        })
    );
    const handleLogsDateEndChange = date => dispatch(
        PMSLocationsActions.setProtectLogsDateFilter({
            end: date,
        })
    );

    //INITIALIZATION
    useEffect(() => {
        if (!timezone)
            return;

        dispatch(PMSLocationsActions.setProtectLogsDateFilter({
            begin: TimeHelper.localizedStartOfTodayIsoString(timezone),
            end: TimeHelper.localizedEndOfTodayIsoString(timezone),
        }));
    }, [dispatch, locationUid, timezone]);

    useEffect(() => {
        dispatch(PMSLocationsActions.getProtectLogsFirstPage());
    }, [dispatch, begin, end]);

    return (
        <GenericLogsPage
            handleNextPage={handleNextPage}
            handleLogsDateStartChange={handleLogsDateStartChange}
            handleLogsDateEndChange={handleLogsDateEndChange}
            handleRefreshLogs={handleRefreshLogs}

            startIsoString={begin}
            endIsoString={end}

            isRequesting={isRequesting}
            requestingFirst={isRequestingFirst}
            isThereLogs={logs.length !== 0}
            timezone={timezone}
            nextPage={nextPage}

            content={
                <LogsTable
                    devices={devices}
                    logs={logs}
                    isSmall={false}
                    timezone={timezone}
                />
            }
        />
    )
}
